export default function validateQuerySlug(queryObj) {
  // If queryObj.name is a number, convert it to a string
  if (!isNaN(queryObj?.name) && queryObj?.name) {
    return {
      ...queryObj,
      p: queryObj?.name,
      name: undefined,
    }
  }
  return queryObj
}
